export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-rose-600 via-red-500 to-amber-500 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=abstract%20geometric%20overlay%20pattern%20with%20subtle%20diagonal%20lines%2C%20warm%20tone%2C%20modern%20tech%20feel&width=800&height=600&seq=app-bg-pattern&orientation=landscape')",
            backgroundSize: "cover",
          }}></div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-white/20 text-background-50 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              移动端入口
            </span>
            <h2 className="text-xl md:text-2xl font-bold text-background-50 mb-3 font-heading">
              随时随地，掌上吃瓜
            </h2>
            <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-6 max-w-lg lg:max-w-none">
              51吃瓜网站移动端适配完美，支持51吃瓜在线观看视频与图文快讯，无论通勤路上还是睡前摸鱼，打开手机即可获取最新51吃瓜爆料与黑料信息。下拉即刷、点击即看，吃瓜体验流畅顺滑。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <a href="#cards" onClick={(e) => { e.preventDefault(); const el = document.querySelector("#cards"); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" }); }} className="px-6 py-2.5 bg-background-50 text-rose-600 font-semibold rounded-lg text-sm cursor-pointer whitespace-nowrap transition-transform hover:scale-105">
                <i className="ri-smartphone-line mr-1.5"></i> 立即体验
              </a>
              <span className="text-background-50/70 text-xs whitespace-nowrap">
                无需下载 · 浏览器打开即用
              </span>
            </div>
          </div>

          <div className="relative z-10 w-48 md:w-56 flex-shrink-0">
            <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-white/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=smartphone%20mockup%20showing%20news%20feed%20with%20warm%20red%20and%20dark%20theme%2C%20entertainment%20gossip%20content%20on%20screen%2C%20modern%20mobile%20UI%2C%20clean%20design%2C%20cinematic%20lighting&width=600&height=1067&seq=app-mockup&orientation=portrait"
                alt="51吃瓜网站移动端界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}